import {
  TestAttributePhaseEnum,
  type TestTemplateAttribute,
} from "@brewbase/db/types";
import type {
  BaseTemplateAttribute,
  EditorSection,
} from "@/features/template-block-editor/types";

const phaseOf = (a: BaseTemplateAttribute) => (a as TestTemplateAttribute).phase ?? null;

function phaseSection(
  phase: TestAttributePhaseEnum | null,
  title: string,
  description: string,
): EditorSection {
  return {
    title,
    description,
    phase,
    compactEmpty: true,
    select: (all) => all.filter((a) => phaseOf(a) === phase),
  };
}

/**
 * A test template's attributes grouped by phase, in the order a test is
 * worked (as the session view groups them). Adding an attribute in a section
 * gives it that phase; changing an attribute's phase moves it.
 */
export const TEST_PHASE_SECTIONS: EditorSection[] = [
  phaseSection(TestAttributePhaseEnum.PREP, "Prep", "Before measuring: the sample and its preparation."),
  phaseSection(TestAttributePhaseEnum.MEASURE, "Measure", "What is measured or read."),
  phaseSection(TestAttributePhaseEnum.RESULT, "Result", "Each is a column of the test in the samples grid."),
  phaseSection(TestAttributePhaseEnum.REVIEW, "Review", "Checks once the results are in."),
  phaseSection(null, "Other", "No phase."),
];
